import * as TK from 'components/post/HomeFeedPosts/translations/constants';
import { Translations } from 'translations/types';

export const homeFeedPostsEnUsLocale: Translations = {
  [TK.HOME_FEED_POSTS_LOADING_MORE]: 'Loading more posts',
};
